import React, { Fragment } from "react";
import AccountSettingContain from "../../../Component/Account/AccountSettings";

const AccountSettings = () => {
  return (
    <Fragment>
      {/* <Breadcrumbs parent="AccountSettings" title="Account Settings" /> */}
      {/* <TutorAccountContain /> */}
      <AccountSettingContain />
    </Fragment>
  );
};

export default AccountSettings;
